<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card">
          <div class="card-body">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col mt-4">
                <h4 class="ms-lg-4">Payment Prorities</h4>
              </div>
              <div
                class="col-lg-2 col-md-3 col-sm-4 col-12 d-flex justify-content-end add-btn me-5"
              >
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-none d-sm-block "
                  type="button"
                  @click:button="BackToPaymentConfiguration()"
                >
                  Back To Payment Configuration
                </llp-button>
                <llp-button
                  classNames="btn-secondary d-block d-sm-none new-btn"
                  @click:button="BackToPaymentConfiguration()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>
            <div class="row ms-lg-3">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="role" :aria-label="Role">
                  Payment Methods:
                </llp-label>
                <select
                  id="status"
                  class="form-control select-dropdown"
                  v-model="selectPaymentName"
                  @change="selectedPaymentMethodProrities"
                >
                  <option value="" disabled selected>
                    Select payment method name
                  </option>
                  <option
                    :value="method.id"
                    :key="method.id"
                    v-for="method in selectPaymentMethod"
                  >
                    {{ method.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-lg-6 ms-lg-3">
                <Draggable
                  v-model="paymentMethods"
                  :item-key="'id'"
                  class="list-group m-2"
                  handle=".handle"
                >
                  <template #item="{ element, index }">
                    <div
                      class="list-group-item handle d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <strong>{{ element.name }}</strong
                        ><br />
                      </div>
                      <span class="badge bg-secondary"
                        >Priority: {{ index + 1 }}</span
                      >
                    </div>
                  </template>
                </Draggable>
              </div>
            </div>
            <div class="mt-4 ms-lg-4">
              <button class="btn btn-secondary" @click="savePriorities">
                Save Priority
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
import { defineComponent } from "vue";
import Draggable from "vuedraggable";

export default defineComponent({
  name: "PaymentPriority",
  components: {
    Draggable,
  },
  data() {
    return {
      selectPaymentMethod: [],
      selectPaymentName: "",
      paymentMethods: [],
    };
  },
  mounted() {
    this.fetchingPaymentProrityMethods();
  },
  methods: {
    BackToPaymentConfiguration() {
      this.$router.push("/payment-configuration");
    },

    async savePriorities() {
      try {
        const priorities = this.paymentMethods.map((method, index) => ({
          id: method.id,
          priority: index + 1,
          selected_method: this.selectPaymentName,
        }));
        const response = await NetworkService.post("/store-payment-methods-priority", priorities);
        setTimeout(()=>{
           this.$router.push("/payment-configuration");
        },2000)
        
         this.$refs.toast.show(response.data.message)
      } catch (error) {
        this.$refs.toast.show("Unable to save the payment priorities", "error");
      }
    },
    async fetchingPaymentProrityMethods() {
      try {
        const response = await NetworkService.get("/payment-methods-dropdown");
        this.selectPaymentMethod = response.data;
      } catch (error) {
        this.$refs.toast.show("Unable to fetch payment methods", "error");
      }
    },
    async selectedPaymentMethodProrities() {
      try {
        const response = await NetworkService.get(
          `/payment-gateways-sorting/${this.selectPaymentName}`
        );
        this.paymentMethods = response.data.map((pg) => ({
          id: pg.pg_id,
          name: pg.payment_gateway_name,
        }));
      } catch (error) {
        this.$refs.toast.show("Unable to fetch payment priorities", "error");
      }
    },
  },
});
</script>

<style scoped>
.list-group-item {
  cursor: move;
  user-select: none;
}
</style>
